import isNil from 'lodash/isNil';
import get from 'lodash/get';

export const AUTH_SET_INFUSE_CONFIG = (state, { brandNew, config }) => {
  const { store, ...data } = config;

  const storage = JSON.parse(sessionStorage.getItem('infuse'));
  const storeDefined = !isNil(store);
  const storageDefined = storage && !isNil(storage[config.snippetId]);
  const snippetId = config.snippetId || get(state, 'config.snippetId');

  // eslint-disable-next-line no-empty
  if (storeDefined && snippetId) {
    sessionStorage.setItem(
      'infuse',
      JSON.stringify({
        ...(storage || []),
        [snippetId]: { closed: +store.closed, completed: +store.completed }
      })
    );
  }

  return {
    ...state,
    config: {
      ...(state.config || []),
      ...data
    },
    state: {
      ...((state && state.state) || []),
      ...(((store || storageDefined) &&
        snippetId && {
          [snippetId]: {
            ...(!brandNew && get(state, `state.${snippetId}`, [])),
            ...(storeDefined ? { closed: brandNew ? 0 : +store.closed } : storage[snippetId])
          }
        }) ||
        [])
    }
  };
};

export const AUTH_SET_INFUSE_API_RESPONSE = (state, { api }) => ({
  ...state,
  api
});
